export const formatFirstAndLastName = (fullname: string) => {
  const names = fullname.split(' ');
  return `${names[0]} ${names[names.length - 1]}`;
};
